module.exports = __webpack_public_path__ + "media/editable.6752fa12.mp4";